import type { ModuleAccessKey, ModuleAccessMarker } from "../../lib/accessRequests";
import { AccessGate } from "./AccessGate";

type ModuleAccessGateProps = {
  title: string;
  moduleKey: ModuleAccessKey;
  marker?: ModuleAccessMarker | null;
  isLoading?: boolean;
  className?: string;
  children: React.ReactNode;
};

export function ModuleAccessGate({
  title,
  moduleKey,
  marker,
  isLoading,
  className,
  children,
}: ModuleAccessGateProps) {
  return (
    <AccessGate
      module={moduleKey}
      marker={marker}
      title={title}
      className={className}
      placeholder="dashboard-card"
      isLoading={isLoading}
    >
      {children}
    </AccessGate>
  );
}

export { ModuleNoAccessCard } from "./AccessGate";
